module.exports = __webpack_public_path__ + "media/images/product/f_m-23a61b79727f6f2e4c761201c9fa115b.png";